import { TableBody } from "@components/modules/common/table";
import { type TColumnDef, useTable } from "@components/ui-kit/table";
import { t } from "@lingui/macro";
import type {
  UserMonthlyReport,
  UserMonthlyReportOrderByColumnEnum,
  UserMonthlyReportPerTeam,
} from "@src/__generated__/urql-graphql";
import { formatDuration, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import { useStore } from "../../store";
import { UserName } from "./UserName";

const cols: TColumnDef<UserMonthlyReport, UserMonthlyReportOrderByColumnEnum> =
  [
    {
      key: "users",
      header: () => t`Users`,
      render: (r) => <UserName row={r} />,
    },
    {
      key: "totalPerMonth",
      header: () => t`Total per month`,
      render: (r) => <div>{formatDuration(r.total_tracked_time)}</div>,
    },
  ];

interface TableProps {
  rows: UserMonthlyReport[];
}

const Table = ({ rows }: TableProps) => {
  const store = useStore();

  const teamsCols: TColumnDef<
    UserMonthlyReport,
    UserMonthlyReportOrderByColumnEnum
  > = store.userMonthlyReportTeams.map((team) => ({
    key: team.id,
    header: team.name,
    render: (r) => {
      const teamTrackedTime: UserMonthlyReportPerTeam | undefined =
        r.tracked_time_per_team.find(({ team_id }) => team_id === team.id);

      return (
        <div>
          {formatDuration(teamTrackedTime?.tracked_time!)} (
          {percent.format(teamTrackedTime?.tracked_time_percentage!)})
        </div>
      );
    },
  }));

  const { table } = useTable(rows, [...cols, ...teamsCols], {
    orderedBy: store.orderBy.clauses,
  });

  return <TableBody table={table} />;
};

export default observer(Table);
